module.exports = __webpack_public_path__ + "media/images/svg/file-49f08af503163494e682e3fcd54c9112.svg";